import React from 'react'
import "./Categories.scss"
import { Link } from 'react-router-dom'
import useFetch from '../../hooks/useFetch'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { buildSrcSet } from '../../utils/imageSrcSet'

// One column up to 768px, three columns (grid capped at 2000px) above.
const TILE_SIZES = "(max-width: 768px) 100vw, (min-width: 2000px) 667px, 33vw";

const gridPositions = [
    { className: "div1" },
    { className: "div2" },
    { className: "div3" }
];

const CategoryItem = ({ category, className }) => (
    <div className={`categories-item ${className}`}>
        <img
            src={process.env.REACT_APP_UPLOAD_URL + (category.img.formats?.large?.url || category.img.url)}
            srcSet={buildSrcSet(category.img)}
            sizes={TILE_SIZES}
            alt={category.title}
            loading="eager"
            decoding="async"
        />
        <Link className="link" to={`/products/${category.documentId}`}>
            <span className="label-box">
                <FormattedMessage id={category.title} />
            </span>
        </Link>
    </div>
);

const MemoizedCategoryItem = React.memo(CategoryItem);

const Categories = () => {
    const locale = useSelector(state => state.locale);

    const { data, loading, error } = useFetch(`/categories?&populate=*`);

    const man_category = data?.find(category => category.title_eng === "Man");
    const woman_category = data?.find(category => category.title_eng === "Woman");
    const luxury_category = data?.find(category => category.title_eng === "Luxury");

    // Place categories in grid order
    const categoriesOrdered = [woman_category, man_category, luxury_category];

    return (
        <div className="categories-grid parent">
            {categoriesOrdered.map((category, idx) =>
                category ? (
                    <MemoizedCategoryItem
                        key={category.documentId || category.id}
                        category={category}
                        className={gridPositions[idx].className}
                    />
                ) : null
            )}
        </div>
    );
};

export default Categories;
